module.exports = __webpack_public_path__ + "static/media/idgaf.45c40162.wav";